import { render, staticRenderFns } from "./backendAdaptationVersion.vue?vue&type=template&id=21575634&scoped=true&"
import script from "./backendAdaptationVersion.vue?vue&type=script&lang=js&"
export * from "./backendAdaptationVersion.vue?vue&type=script&lang=js&"
import style0 from "./backendAdaptationVersion.vue?vue&type=style&index=0&id=21575634&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21575634",
  null
  
)

export default component.exports